import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'unregistered-repos',
});

export const repositoryRouteRef = createSubRouteRef({
  id: 'unregistered-repos:repository',
  parent: rootRouteRef,
  path: '/repository/:repoSlug',
});

export const generateRouteRef = createSubRouteRef({
  id: 'unregistered-repos:generate',
  parent: rootRouteRef,
  path: '/repository/:repoSlug/generate',
});

export const previewRouteRef = createSubRouteRef({
  id: 'unregistered-repos:preview',
  parent: rootRouteRef,
  path: '/repository/:repoSlug/preview/:generationId',
});

export const batchJobsRouteRef = createSubRouteRef({
  id: 'unregistered-repos:batch-jobs',
  parent: rootRouteRef,
  path: '/batch-jobs',
});
